import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Analytics
import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { registerWithEmailAndPassword, loginWithEmailAndPassword } from '../actions/authActions';
import { setAlert } from '../actions/alertActions';

// Components
import { Button } from '@mui/material';
import GoogleBtn from '../components/common/GoogleBtn';
import Navbar from '../components/Navbar';
import Alert from '../components/common/Alert';

// Imgs
import Logo from '../components/common/Logo_Round';

// Initial State
const initialState = {
    email: '',
    password: ''
}

const Authentication = ({
    registerWithEmailAndPassword, 
    loginWithEmailAndPassword,
    setAlert,
    auth: {
        account_loading,
        isAuthenticated
    }
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // State for form data
    const [formData, setFormData] = useState(initialState);

    const PATHNAME = window.location.pathname;

    // Destructure the email value from form data
    const { email, password } = formData;

    // Function to handle input change
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

    // Function to validate email format
    const validateEmail = (input) => {

        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      
        if (input.match(validRegex)) {
      
          return true;
      
        } else {
      
          return false;
      
        }
    }

    // Function to handle form submission
    const onSubmit = async e => {
        e.preventDefault();

        if(email === '') {
            setAlert('Email is required.', 'danger');
        } else if (!validateEmail(email)) {
            setAlert('Invalid email address!', 'danger');
        } else if (password === '') {
            setAlert('Password is required.', 'danger');
        } else {

            // Start Authentication
            if(PATHNAME == '/signup') {
                registerWithEmailAndPassword(email, password);
            } else {
                loginWithEmailAndPassword(email, password);
            }
            
        }
    }

    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
        mixpanel.track("Auth Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    // Redirect if the user is already logged in
    if(isAuthenticated) {

        window.location.href = "/";
    }

    return (
        <Fragment>

            <div className='register_container login'>
                <div className='register_content_container login'>
                    <div className='register_content'>
                        <div style={{boxSizing:'border-box', textAlign:'center'}}>
                            {/* Logo */}
                            <img alt="Interview Cheater" loading="lazy" width="20" height="20" decoding="async" src={Logo} style={{borderRadius: '50%', width: '50px', height: '50px'}} />
                            {/* Alert */}
                            <Alert />
                            {/* Title */}
                            <div className='register_title login' >
                                {PATHNAME == '/signup' ? 'Create your account' : 'Log in to Interview Cheater'}
                            </div>
                        </div>

                        <div style={{height: '10px'}}></div>

                        {/* <GoogleBtn />

                        <div style={{height: '10px'}}></div>

                        <p style={{fontSize: '1rem', color: 'rgb(152,152,152)', fontWeight: 600, margin: 0, textAlign: 'center'}}>
                            OR CONTINUE WITH EMAIL
                        </p> */}

                        <div>
                            {/* Input fields */}
                            <div className='register_form_inputs'>       
                                {/* Input & Label */}
                                <div className='register_input_container login'>
                                    <input 
                                        type="text"
                                        placeholder="Email address"
                                        className="input"
                                        name="email"
                                        value={email}
                                        onChange={e => onChange(e)}
                                    />
                                </div>
                                {/* Password*/}
                                <div className='register_input_container login'>
                                    <input 
                                        type="password"
                                        placeholder="Password"
                                        className="input"
                                        name="password"
                                        value={password}
                                        maxlength="30"
                                        onChange={e => onChange(e)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Actions */}
                        <div className='register_btns' style={{display: 'flex', alignItems:'center', flexDirection:'column'}}>
                            <Button 
                                onClick={onSubmit} 
                                className="sidebar__tweet"
                                fullWidth
                                disabled={account_loading}
                            > 
                                {account_loading ? 
                                    'Processing...' : 
                                    PATHNAME == '/signup' ? 'Create account' : 'Sign in'}
                            </Button>
        
                        </div>

                        <div style={{height: '10px'}}></div>
                        
                        {/* Form footer - small text */}                    
                        <div className='register_redirect' style={{color: 'rgb(152,152,152)'}}>
                            {PATHNAME == '/signup' ? (
                                <div>
                                    <div>
                                        Already have an account?
                                    </div>
                                    <div style={{marginLeft: '5px'}}>
                                        <a href='/signin' style={{color:'rgb(152,152,152)', fontWeight:'bold', cursor: 'pointer'}}>
                                            Sign in →
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div>
                                        Don't have an account?
                                    </div>
                                    <div style={{marginLeft: '5px'}}>
                                        <a href='/signup' style={{color:'rgb(152,152,152)', fontWeight:'bold', cursor: 'pointer'}}>
                                            Sign up →
                                        </a>
                                    </div>
                                </div>
                            )}
                            
                        </div>
                        
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

Authentication.propTypes = {
    registerWithEmailAndPassword: PropTypes.func.isRequired,
    loginWithEmailAndPassword: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    registerWithEmailAndPassword,
    loginWithEmailAndPassword,
    setAlert
})(Authentication);